import React from "react";
import PropTypes from "prop-types";

import { Input, Field, Control, Label } from "rbx";
import { SystemCodeSelect } from "../inputs";

function VehicleFilters({ filters, onChange }) {
  const handleChange = e => {
    const updates = { ...filters };
    updates[e.target.name] =
      e.target.name === "VehicleTypeRecIdRef"
        ? parseInt(e.target.value)
        : e.target.value;
    onChange(
      Object.keys(updates).reduce((a, c) => {
        if (String(updates[c]).length) {
          a[c] = updates[c];
        }
        return a;
      }, {})
    );
  };

  return (
    <React.Fragment>
      <Field kind="group">
        <Control>
          <Label>Number</Label>
          <Input
            autocomplete="new"
            name="VehicleNumber_contains"
            type="text"
            value={filters.VehicleNumber_contains}
            onChange={handleChange}
          />
        </Control>
        <Control>
          <Label>Description</Label>
          <Input
            autoComplete="new"
            name="Description_contains"
            type="text"
            value={filters.Description_contains}
            onChange={handleChange}
          />
        </Control>
        <Control expanded>
          <SystemCodeSelect
            // readOnly={!editing}
            icon="truck"
            label="Type"
            lookup={{ Category: "Fleet", Code: "VehicleType" }}
            name="VehicleTypeRecIdRef"
            showHelp={false}
            value={filters?.VehicleTypeRecIdRef}
            onChange={handleChange}
          />
        </Control>
      </Field>
    </React.Fragment>
  );
}
VehicleFilters.propTypes = {
  filters: PropTypes.object,
  onChange: PropTypes.func
};
export default VehicleFilters;
